import React       from 'react'
import { words }   from 'utils/dictionary';
import { objType } from 'types';



const useShowGrades = (
    val:  objType,
    lang: string,
) => {

  const [grades, showGrades] = React.useMemo(() => {

    const chars: { [key: string]: string } = {
      '1': words['grade1'][lang],
      '2': words['grade2'][lang],
      '3': words['grade3'][lang],
      '4': words['grade4'][lang],
      '5': words['grade5'][lang],
      '6': words['grade6'][lang],
      '7': words['grade7'][lang]
    };

    const  grades_ = !!val.classes ? val.classes.replace(/[1234567]/g,(v: string) => { return chars[v] }).split('').join(',') : '';
    const  gr      = !!grades_ ? `${ words['Grades'][lang] } : ${ grades_ }` : '';
    return[
      gr,
      !!val.classes && ( val.origin === 'teacherLessons' || val.origin === 'mivdakim' )
    ]
  },[val, lang])

   
   return{grades, showGrades}

}

export default useShowGrades

